export const data = {
    account_fame_points: 100,
    chevron: 200,
    spare_parts: 9600,
    clan_fame_points: 300,
}



// WEBPACK FOOTER //
// ./state/__mocks__/account_stats_mock.js